import { doScrollToTop } from '../global/_scroll';
import { scrollTo } from '../../utils/_scrollTo';
import { displayDynamicShippingAlert } from './_displayDynamicShippingAlert';
import { checkExpDateIsNullOrEmpty } from './_checkExpDateIsNullOrEmpty';
import { checkCCNo, checkCVN2, valBillAddress, valGiftCard, valPromoCode } from './_validation';
import { validateCardInfo } from '../../utils/_paymentValidator';

const submitPaymentForm = (form, callingButton) => {
	if ($('#wfEncAccount').length > 0 && $('input[name=CardType2]:checked').val() == 'wfCard') {
		form.piAmount.value = document.creditcard2.piAmount.value;
		if (form.WFCardType.value == 'Dillards AMEX Charge') form.cc_cvc.value = '0000';
		else if (form.WFCardType.value == 'Dillards Charge') form.cc_cvc.value = '000';
		form.expire_month.value = $('#currentMonth').html();
		if (form.expire_month.value < 10 && form.expire_month.value.length < 2) form.expire_month.value = '0' + form.expire_month.value;
		form.expire_year.value = $('#currentYear').html();
		form.action = 'OrderReviewCmd';
		form.URL.value = '';

		form.submit();
	} else {
		if (callingButton == 'Promo') {
			//If Same as Shipping Address is NOT checked and there is an error in the address validation form, then return false and don't allow the Rewards Code to work
			if ($("#billingAddressCheck").prop("checked")) {
				$(':input','#shippingAddressForm').val('');
			}
			
			if ($('#shippingAddressForm').is(':visible')) {
				Dillards.validateThisForm($('#shippingAddressForm'));
				$('#shippingAddressForm button').eq(0).click();
			}
			if ($('#shippingAddressForm .has-error').length > 0) {
				return false;
			}
			
			if ($('#giftCardError').length == 1) {
				$('#giftCardError').remove();
				$('input[name="gcErrorAlert"]').val('');
			}
			if ($('#contactInfoInputWrapper').is(':visible')) {
				Dillards.validateThisForm($('#contactInfoInputWrapper'));
				$('#contactInfoInputWrapper button').eq(0).click();
			}
			
			if ($('#contactInfoInputWrapper .has-error').length > 0) {
				return false;
			}

			if (!valPromoCode(form)) {
				if ($('#paymentWrapper #messages .alert').length > 0) {
					scrollTo('#paymentWrapper #messages');
				}
				return false;
			}
			
			form.action = 'RPMCodeValidateCmd';
			form.URL.value = '';
		} else if (callingButton == 'PromoModal') {
			form.action = 'RPMCodeValidateCmd';
			form.URL.value = '';
		} else if (callingButton == 'Apply') {
			if ($('giftCardApply').length == 1) {
				$('#giftCardApply').prop("disabled", true);
			}
			
			if ($('#rewardsCertError').length == 1) {
				$('#rewardsCertError').remove();
			}

			if ($("#billingAddressCheck").prop("checked")) {
				$(':input','#shippingAddressForm').val('');
			}

			if ($('#shippingAddressForm').is(':visible')) {
				Dillards.validateThisForm($('#shippingAddressForm'));
				$('#shippingAddressForm button').eq(0).click();
			}

			if ($('#shippingAddressForm .has-error').length > 0) {
				return false;
			}

			let pinForm = $('#gcPin').is(':visible'),
				emptyPin = $('#gcPin').val() == '' || $('#gcPin').val() == undefined,
				noPinEntered = pinForm && emptyPin,
				pinLength = $('#gcPin').val().length;
				
			if (pinForm && (noPinEntered || pinLength < 3)) {
				let pinLengthErrorEle = document.getElementById('giftCardPINError');
				if (pinLengthErrorEle) {
					pinLengthErrorEle.parentElement.classList.add('has-error');
					pinLengthErrorEle.innerText='A 3-digit PIN is required.';
					if ($('giftCardApply').length == 1) {
						$('#giftCardApply').prop("disabled", false);
					}
				}				
				
				return false;
			}
			if (noPinEntered || !valGiftCard(form)) {
				if (noPinEntered && !$('#newPinError').length > 0) {
					let pinError = `<span id="newPinError" class="popover-error" style="display:inline-block!important" role="status" aria-live="polite">( Please enter valid pin )</span>`;
					$('#pinLengthError').remove();
					$(pinError).appendTo('.hidden-form-gc-pin label');
					if ($('giftCardApply').length == 1) {
						$('#giftCardApply').prop("disabled", false);
					}
				}
				
				return false;
			}
			form.giftCardProcessingType.value = 'add';
			var giftCardNumber = form.giftCertificate.value,
				mask = '';
			for (var i = 0; i < giftCardNumber.length - 5; i++) {
				mask = mask + '*';
			}
			form.maskedAccount.value = 'Gift Card ' + mask + giftCardNumber.substring(giftCardNumber.length - 5, giftCardNumber.length);
			form.paymentMethod.value = '';
			form.cc_brand.value = '';
			form.policyId.value = '';
		} else if (callingButton == 'ApplyEcard') {
			//------Check Billing Address Form Validation--------->
			if ($('#shippingAddressForm').is(':visible')) {
				Dillards.validateThisForm($('#shippingAddressForm'));
				$('#shippingAddressForm button').eq(0).click();
			}
			//------/Check Billing Address Form Validation--------->
			//------Check Contact Form Validation--------->
			if ($('#contactInfoInputWrapper').is(':visible')) {
				Dillards.validateThisForm($('#contactInfoInputWrapper'));
				$('#contactInfoInputWrapper button').eq(0).click();
			}
			//------/Check Contact Form Validation--------->
			if ($('#shippingAddressForm .has-error').length > 0) {
				return false;
			}
			if ($('#contactInfoInputWrapper .has-error').length > 0) {
				return false;
			}

			form.giftCardProcessingType.value = 'addEcard';
			form.action = 'EGiftCardProcess';
			form.URL.value = '';
			form.maskedAccount.value = 'eGift Card';
			form.paymentMethod.value = '';
			form.cc_brand.value = '';
			form.policyId.value = '';
		} else if (callingButton == 'checkBalance') {
			if (!valGiftCard(form)) return false;
			form.giftCardProcessingType.value = 'getBalance';
		} else form.giftCardProcessingType.value = '';

		if (callingButton == 'ReviewOrder') {
			handleReviewOrderValidation(form)
		}
		
		form.submit();
	}
};

const handleReviewOrderValidation = (form) => {
	if ($("#billingAddressCheck").prop("checked")) {
		$(':input','#shippingAddressForm').val('');
	}
	
	if ($('input[name=isPayPal]').val() != 'true') {
		if ($('#shippingAddressForm').is(':visible')) {
			Dillards.validateThisForm($('#shippingAddressForm'));
			$('#shippingAddressForm button').eq(0).click();
		}
		if ($('#shippingAddressForm .has-error').length > 0) {
			return false;
		}
	}
	if ($('#giftCardError').length == 1) {
		$('#giftCardError').remove();
	}
	if ($('#rewardsCertError').length == 1) {
		$('#rewardsCertError').remove();
	}

	if ($('#messages .alert').length > 0) {
		$('#messages').empty();
	}

	if (!validateCardInfo()) return false;

	if ($('input[name=isPayPal]').val() != 'true' && $('input[name=isAfterpay]').val() != 'true' && $('input[name=isVenmo]').val() != 'true' && $('input[name=isApplePay]').val() != 'true') {
		//------Check Billing Address Form Validation--------->
		  if ($('#shippingAddressForm').is(':visible')) {
			$('#shippingAddressForm').removeData('validForm');
			Dillards.validateThisForm($('#shippingAddressForm'));
			$('#shippingAddressForm button').eq(0).click();
		 } else {
			  $('#shippingAddressForm').data('validForm', true);
			 $('#shippingAddressForm').data('validFormFailed', false);
		  }
		//------/Check Billing Address Form Validation--------->
		//------Check Contact Form Validation--------->
		if ($('#contactInfoInputWrapper').is(':visible')) {
			Dillards.validateThisForm($('#contactInfoInputWrapper'));
			$('#contactInfoInputWrapper button').eq(0).click();
		}
		//------/Check Contact Form Validation--------->
		if ($('#shippingAddressForm').is(':visible') && $('#shippingAddressForm').hasClass('has-error').length > 0) {

			scrollTo('#shippingAddressForm');
			return false;
		}
		if ($('#contactInfoInputWrapper').is(':visible') && $('#contactInfoInputWrapper .has-error').length > 0) {
			scrollTo('#contactInfoInputWrapper');
			return false;
		}
	}
	if ($('#giftCcard').val() > '' || $('#certificate-pass-promo-code').val() > '') {
		var text = '';
		if ($('#giftCcard').val() > '') text = 'Gift Card';
		if ($('#certificate-pass-promo-code').val() > '')
			text = 'Rewards Certificate or Shopping Pass';
		$('#giftCcard').parents('.form-group').addClass('gc-rewardError');
		displayDynamicShippingAlert('Please click the ADD button to apply your ' + text + '.', 'danger');
		scrollTo('.gc-id');
		setTimeout(() => {
			$('.oneClickOnly').removeAttr('disabled');
			$('.oneClickOnly').css('pointer-events', '');
		}, 3000);
		return false;
	} else {
		//If orderTotal==giftCardsTotal,only giftcard(s) is used to submit order with no credit cards
		//the flag giftCardOnly  is set to true so  there are no front-end checks on credit card fields like Card Number, CVN or Amount
		//the form field isPIAddNeeded is set to "N" so there are no back-end checks on the same credit card fields
		var giftCardOnly = false,
			giftCardsTotal = $('#giftCardsTotal').html(),
			orderTotal = $('#formattedOrderTotal').html();
		if (orderTotal == giftCardsTotal) {
			form.isPIAddNeeded.value = 'N';
			giftCardOnly = true;
		}
		//If there is no remaining amount, that means that all necessary gift cards or credit cards have been added to the order
		//the flag paymentNotNeeded  is set to true so  there are no front-end checks on credit card fields like Card Number, CVN or Amount
		//the form field isPIAddNeeded is set to "N" so there are no back-end checks on the same credit card fields
		var paymentNotNeeded = false,
			remainingAmount = $('#remainingAmount').html();
		if (remainingAmount <= 0) {
			form.isPIAddNeeded.value = 'N';
			paymentNotNeeded = true;
		}
		var isSavedProfileUsed = false;
		if (
			$('input[name=CardType2]:checked').val() == 'savedCard2' &&
			!paymentNotNeeded &&
			$('input[name=isPayPal]').val() != 'true' &&
			$('input[name=isAfterpay]').val() != 'true' &&
			$('input[name=isVenmo]').val() != 'true' &&
			$('input[name=isApplePay]').val() != 'true' 
		) {
			isSavedProfileUsed = true;
			var savedCards = document.QuickCheckoutCC2.savedcards.value,
				paymentDetails = savedCards.split(',');
			form.policyId.value = paymentDetails[0];
			form.cc_brand.value = paymentDetails[1];
			form.updateSaved.value =  paymentDetails[6]; //value is true if card is expired, therefore needs to be updated.
			// Get the expire month and year for the card
			// If a saved Dillards card is used, populate with current month/year
			if ((form.cc_brand.value.trim() == 'Dillards Charge' || form.cc_brand.value.trim() == 'Dillards Private Label') && form.updateSaved.value == 'true') {
				form.expire_month.value = $('#currentMonth').html();
				form.expire_year.value = $('#currentYear').html();
			} else if (form.updateSaved.value == 'true') {
				form.expire_month.value = $('select[name="update_month"] option:selected').val();
				form.expire_year.value = $('select[name="update_year"] option:selected').val();
			} else {
				form.expire_month.value = paymentDetails[2];
				form.expire_year.value = paymentDetails[3];
			}
			
			if (form.expire_month.value < 10 && form.expire_month.value.length < 2) {
				form.expire_month.value = '0' + form.expire_month.value;
			}
			  
			// Get the acc. and cvv
			form.account.value = paymentDetails[4];
			form.maskedAccount.value = paymentDetails[5];
			//alphaNum check on CVN field
			if (
				document.QuickCheckoutCC2.cvv &&
				document.QuickCheckoutCC2.cvv.disabled != true &&
				$('#qcCreditCard .cvnGroup').is(':visible') &&
				!checkCVN2(document.QuickCheckoutCC2.cvv, form.cc_brand.value)
			) {
				return false;
			}
			if (document.QuickCheckoutCC2.cvv) {
				form.cc_cvc.value = document.QuickCheckoutCC2.cvv.value;
				//form.updateSaved.value = 'true';
			}
			form.piAmount.value = document.QuickCheckoutCC2.piAmount.value;
			// setting to true since the credit card would've been encrypted already
			form.skipCheck.value = 'true';
		}
		//check if check out type is Paypal or single gift card is used to checkout, then skip this code section which validates all credit card fields
		if (
			$('input[name=isPayPal]').val() != 'true' &&
			!giftCardOnly &&
			!paymentNotNeeded &&
			!isSavedProfileUsed &&
			$('input[name=isAfterpay]').val() != 'true' &&
			$('input[name=isVenmo]').val() != 'true' &&
			$('input[name=isApplePay]').val() != 'true'
		) {
			form.skipCheck.value = 'false';
			// Get the card type from creditCards.jsp - set the policyId, brand
			var payMethod = document.creditcard2.paymentMethod.value;
			form.paymentMethod.value = payMethod;
			var mySplitResult = payMethod.split(',');
			form.policyId.value = mySplitResult[0];
			form.cc_brand.value = mySplitResult[1];
			// Get the acc. and cvv
			form.account.value = document.creditcard2.account.value;
			form.cc_cvc.value = document.creditcard2.pay_data_cvvNumber.value;
			form.piAmount.value = document.creditcard2.piAmount.value;
			if (document.creditcard2.addCCtoProfile != null) form.addCCtoProfile.value = document.creditcard2.addCCtoProfile.value;
			// Create a comma separated list of PIds and CVVs
			var paymentIns = '',
				pay_data_cvvNos = '',
				cvvInValid = false;
			// Loop through pIds and cvvs sent from credit cards jsp
			$('.PayinstID').each(function (i) {
				paymentIns = paymentIns + this.value + ',';
			});
			//Loop through cvvs from credit card jsps,
			//return false breaks from JQuery loop
			//cvvInValid flag is set to return false from outside the loop in case of invalid cvn
			$('.pay_data_CvvList').each(function (i) {
				pay_data_cvvNos = pay_data_cvvNos + this.value + ',';
				// If CVN field is disabled, then CC has already been auth-ed and hence don't validate CVN field
				if (!$(this).is(':disabled')) {
					if (!checkCVN2(this, form.cc_brand.value)) {
						cvvInValid = true;
						return false;
					}
				}
			});
			if (cvvInValid) {
				scrollTo('#messages');
				return false;
			}
			//alphaNum check on Card Number field
			if (!checkCCNo(document.creditcard2.account)) {
				scrollTo('#messages');
				return false;
			}
			if ($('#expirationDateGroup').is(':visible')) {
				var brand = form.cc_brand.value.trim();
				if (brand == 'Dillards Charge') brand = "Dillard's Credit";
				else if (brand == 'Dillards AMEX Charge') brand = "Dillard's American Express";
				if (
					checkExpDateIsNullOrEmpty(
						$('#creditCardForm select[name=expire_month]').val(),
						$('#creditCardForm select[name=expire_year]').val(),
						'Please enter the Expiration Date as it appears on your ' + brand + ' card'
					)
				) {
					//scrollTo('#messages');
					return false;
				}
				form.expire_month.value = document.creditcard2.expire_month.value;
				form.expire_year.value = document.creditcard2.expire_year.value;
				form.expire_month.value =
					form.expire_month.value < 10 && form.expire_month.value.length < 2 ? '0' + form.expire_month.value : document.creditcard2.expire_month.value;
				form.expire_year.value = document.creditcard2.expire_year.value;
			}
			//alphaNum check on CVN field
			if (
				!document.creditcard2.pay_data_cvvNumber.disabled &&
				$('.cvnGroup').is(':visible') &&
				!checkCVN2(document.creditcard2.pay_data_cvvNumber, form.cc_brand.value)
			)
				return false;
			//check for billing addressId
			// if (!valBillAddress(form)) return false;

			form.paymentInsIds.value = paymentIns;
			form.pay_data_cvvNumbers.value = pay_data_cvvNos;
			// logic for saving the masked value of account before it gets encrypted
			var CCNumber = document.creditcard2.account.value,
				mask = '';
			for (var i = 0; i < CCNumber.length - 4; i++) {
				mask = mask + '*';
			}
			form.maskedAccount.value = form.cc_brand.value + mask + CCNumber.substring(CCNumber.length - 4, CCNumber.length);
			if (typeof ProtectPANandCVV != 'undefined') {
				var cardNum = document.creditcard2.account.value,
					cvv = document.creditcard2.pay_data_cvvNumber.value;
				try {
					var result = ProtectPANandCVV(cardNum, cvv, true);
					if (result != null) {
						if (result[0] != null && result[0] != cardNum){
							form.account.value = result[0];
						} else {
							if (result[0] === cardNum){
								$("<input type='hidden' value='clearCardNum' />").attr('id', 'p2pError').attr('name', 'p2pError').appendTo(form);
							}else{
								$("<input type='hidden' value='accountNull' />").attr('id', 'p2pError').attr('name', 'p2pError').appendTo(form);
							}
							form.account.value = '';
						}
						
						if (result[1] != null){
							form.p2pcvv.value = result[1];
						}
						
						if (result[2] != null){
							form.integrityCheck.value = result[2];
						}
						
						if (PIE.key_id != null){
							form.keyId.value = PIE.key_id;
						}
						
						if (PIE.phase != null){
							form.phaseId.value = PIE.phase;
						}								
					} else {
						$('#content-wrapper').append('<div class="hidden pointToPoint-error-tracking">ProtectPANandCVV returned null result</div>');
						$("<input type='hidden' value='result' />").attr('id', 'p2pError').attr('name', 'p2pError').appendTo(form);
						form.account.value = '';
					}
				} catch (e) {
					$('#content-wrapper').append('<div class="hidden pointToPoint-error-tracking">Error calling ProtectPANandCVV:' + e + '</div>');
					form.account.value = '';
				}
			} else {
				$('#content-wrapper').append('<div class="hidden pointToPoint-error-tracking">ProtectPANandCVV not defined</div>');
				form.account.value = '';
			}
		}

		if ($('input[name=isPayPal]').val() == 'true') {
			$("<input type='hidden' value='true' />").attr('id', 'isPayPal').attr('name', 'isPayPal').appendTo(form);
			form.piAmount.value = document.creditcard2.piAmount.value;
		}

		if ($('input[name=isAfterpay]').val() == 'true') {
			$("<input type='hidden' value='true' />").attr('id', 'isPayPal').attr('name', 'isAfterpay').appendTo(form);
			form.piAmount.value = document.creditcard2.piAmount.value;
		}
		
		if ($('input[name=isApplePay]').val() == 'true') {
			$("<input type='hidden' value='true' />").attr('id', 'isApplePay').attr('name', 'isApplePay').appendTo(form);
			form.piAmount.value = document.creditcard2.piAmount.value;
		}

		form.action = 'OrderReviewCmd';
		form.URL.value = !giftCardOnly && !paymentNotNeeded ? '' : 'OrderSummaryView';
	}
} 
export { submitPaymentForm, handleReviewOrderValidation };
